import { http } from "./http";

export interface TemplateModuleOption {
  key: string;
  name: string;
  description: string;
  default: boolean;
  requires: string[];
  tables: string[];
}

export interface ProjectTemplate {
  id: string;
  key: string;
  name: string;
  description: string | null;
  stack: string | null;
  is_default: boolean;
  is_active: boolean;
  version?: string | null;
  modules?: string[];
  module_options?: TemplateModuleOption[];
}

export interface TemplateVersion {
  id: string;
  version: string;
  changelog: string | null;
  is_current: boolean;
  created_at: string | null;
}

export const templateService = {
  list: () => http.get<ProjectTemplate[]>("/templates"),
  versions: (key: string) => http.get<TemplateVersion[]>(`/templates/${key}/versions`),
};
